




























































































import {mapGetters} from 'vuex';
import {CATEGORY_LIMIT} from '@/store/constants';
import Vue, {PropType} from 'vue';
import {AdvertCategory, CategoryAPI} from '#/Category';
import {TranslateResult} from 'vue-i18n';

interface ComponentData {
  categoryHelper: boolean;
  dialog: {
    display: boolean;
    selectedCategories: AdvertCategory[];
    errorDisplay: boolean;
  };
}

export default Vue.extend({
  name: 'AdvertCreationCategorySelection',

  props: {
    advertCategories: {
      type: Array as PropType<AdvertCategory[]>,
      required: true,
    },
    errors: {
      type: Array as PropType<string[]>,
      required: true,
    },
    help: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },

  data: (): ComponentData => ({
    categoryHelper: false,
    dialog: {
      display: false,
      selectedCategories: [],
      errorDisplay: false,
    },
  }),

  computed: {
    ...mapGetters([
      'categories',
    ]),
    catLimit(): number {
      return CATEGORY_LIMIT;
    },
    hasNoCategories(): boolean {
      return this.advertCategories.length === 0;
    },
    categoriesSelectionLabel(): TranslateResult {
      return this.hasNoCategories
          ? this.$t('advert.creation.fields.category.select')
          : this.$t('advert.creation.fields.category.modify');
    },
  },

  methods: {
    /**
     * Retire de la selection la dernière catégorie sélectionnée si elle n'est pas sélectionnable
     */
    onActiveCategory(selection: CategoryAPI[]): void {
      this.dialog.errorDisplay = selection.length > CATEGORY_LIMIT;
    },
    /**
     * Ouvre la fenêtre de dialogue pour afficher l'arbre des catégories.
     * Si des catégories sont déjà sélectionnées, elles peuplent les valeurs actives du TreeView
     */
    onOpenDialog(): void {
      this.dialog.selectedCategories = this.advertCategories.map(ad => ({...ad}));
      this.dialog.display = true;
    },
    /**
     * Retire à l'annonce une catégorie de sa liste
     */
    onRemoveCategory(categoryId: number): void {
      this.$emit('update:advert-categories', this.advertCategories.filter(cat => cat.id !== categoryId));
    },
    /**
     * Retire une catégorie sélectionnée depuis la fenêtre de dialogue
     */
    removeCategorySelection(index: number): void {
      this.dialog.selectedCategories
          .splice(this.dialog.selectedCategories.length - index - 1, 1);
    },
    /**
     * Quand l'utilisateur valide les catégories sélectionnées, on les fait remonter au parent.
     * Puis on ferme la fenêtre de selection
     */
    onValidSelection(): void {
      this.$emit('update:advert-categories', this.dialog.selectedCategories.reverse());
      this.dialog.display = false;
    },
  },
});
